import type { ExistingItemRef } from "./types";

/**
 * G-119: the server refuses a second active item with the same name with a
 * 409 whose body carries `code: "DUPLICATE_NAME"` and the twins. This reads
 * that body off the thrown request error, so a page can ask "create anyway?"
 * instead of showing a bare conflict — and so the invoice page's SKU-collision
 * retry never mistakes it for a SKU conflict.
 */
export function duplicateNameFromError(err: unknown): ExistingItemRef[] | null {
  if (!err || typeof err !== "object") return null;
  const body = (err as { status?: number; body?: unknown }).body;
  if (!body || typeof body !== "object") return null;
  const b = body as { code?: unknown; details?: { existing?: unknown } };
  const existing = b.details?.existing;
  if (b.code !== "DUPLICATE_NAME" || !Array.isArray(existing)) return null;
  return existing.filter(
    (e): e is ExistingItemRef =>
      !!e && typeof e === "object" && typeof (e as ExistingItemRef).id === "string",
  );
}
